import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MedicineListComponent} from "../../../store-management/medicine/medicine-list/medicine-list.component";
import {MedicineService} from "../../../store-management/services/medicine.service";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {ImportMedicinesFormComponent} from "../../../store-management/medicine/import-medicines-form/import-medicines-form.component";
import {MessageType} from "../../../shared/redux-store/session";

@Component({
  selector: 'vb-medicines-view',
  templateUrl: './medicines-view.component.html',
  styleUrls: ['./medicines-view.component.css']
})
export class MedicinesViewComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit {

  searchTerm: FormControl = new FormControl();

  @ViewChild('medicineList')
  medicineList: MedicineListComponent;

  @ViewChild('importMedicinesModal')
  importMedicinesModal: GenericModalComponent;

  @ViewChild('importForm')
  importForm: ImportMedicinesFormComponent

  importMedicinesData: FormGroup;

  selectedItems = [];

  constructor(sessionActions: SessionActions, private medService: MedicineService, private fb: FormBuilder, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Neues Medikament hinzufügen',
        icon: 'fa-plus',
        helpText: 'Ein neues Medikament manuell zur Medikamentenliste hinzufügen (dies legt keinen Artikel und/oder Bestand in der Lagerverwaltung an)',
        action: () => this.onAddMedicineClicked.apply(this)
      },
      {
        label: 'Medikamente in Lagerverwaltung importieren',
        icon: 'fa-upload',
        helpText: 'Legt für die ausgewählten Medikamente verknüpfte Artikel in der Lagerverwaltung an',
        action: () => this.onImportMedicinesClicked.apply(this)
      }
    ]

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.medicineList.getComponentData().forEach(d => this.addComponentData(d));
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onAddMedicineClicked() {
    this.medicineList.onAddMedicineClicked();
  }

  onImportMedicinesClicked() {
    this.importForm.ngOnInit();
    this.importForm.control = ImportMedicinesFormComponent.initControl(this.fb);
    this.importForm.medicines = this.medicineList.rows.filter(i => this.selectedItems.find(s => s == i.cuid) != null);
    this.importMedicinesModal.show();
  }

  onExecuteImportClicked() {
    let data = this.importForm.control.value;
    this.medService.importMedicines(data.supplier_id, data.medicine_data, data.administration_unit_id).toPromise()
      .then(res => this.sessionActions.pushMessage('Medikamente wurden erfolgreich importiert!', MessageType.SUCCESS, 'Medikamenten-Import'));
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/view-components/medicines-view/medicines-view.component.ts